// @ts-nocheck

export const SpecialFilterValues = { WINAMAX_TV_FILTER: -1 };
